import styled from 'styled-components';
import { Box, Text } from '@rsos/base-components';
import { BoxProps } from '@rsos/base-components/Box';
import { handleHoveredButtonCSS } from '@rsos/components/capstone/HoveredButtons/helpers';
import { HOVERED_COPY_BUTTON_WIDTH } from '../../HoveredButtons/HoveredButtons.styles';

interface CopyableBoxProps extends BoxProps {
  isCopied: boolean;
  isHistoricLocation?: boolean;
}

export const IconWrapper = styled(Box).attrs({
  color: 'secondaryText',
})``;

export const CopyableBox = styled(Box).attrs<CopyableBoxProps>(
  ({ isCopied }) => ({
    horizontal: true,
    position: 'relative',
    bg: isCopied ? 'highlights' : 'inherit',
    align: 'center',
  }),
)<CopyableBoxProps>`
  ${props => !props.isHistoricLocation && handleHoveredButtonCSS}
  &:hover {
    cursor: 'auto';
    ${props =>
      !props.isCopied &&
      !props.isHistoricLocation &&
      `background: ${props.theme.colors.foreground};`}
  }
`;

export const AddressBox = styled(Box).attrs(() => ({
  p: 0,
  color: 'primaryText',
  width: '100%',
  overflow: 'hidden',
}))``;

export const LocationText = styled(Text).attrs(({ fontWeight = 'bold' }) => ({
  ellipsis: true,
  fontWeight: fontWeight,
  size: 'large',
  marginTop: '4px',
}))``;

export const Address = styled(Box).attrs(() => ({
  pr: '8px',
  width: '100%',
}))``;

export const CopyableLocation = styled(CopyableBox)`
  &:hover ${Address} {
    width: calc(
      100% -
        ${props =>
          props.isHistoricLocation ? '0px' : HOVERED_COPY_BUTTON_WIDTH}px
    );
  }
`;

export const RowBox = styled(Box).attrs(() => ({
  horizontal: true,
  position: 'relative',
  justify: 'space-between',
  align: 'flex-start',
}))``;
